import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './authApi';

export const denominationApi = createApi({
  reducerPath: 'denominationApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Denomination'],
  endpoints: (builder) => ({

    // GET /denominations?currency_code=INR — static reference data, cache indefinitely
    getDenominations: builder.query({
      query: ({ currency_code = 'INR' } = {}) => ({
        url: '/denominations',
        method: 'GET',
        params: { currency_code },
      }),
      transformResponse: (response) => response?.data?.denominations || [],
      providesTags: [{ type: 'Denomination', id: 'LIST' }],
      keepUnusedDataFor: Infinity,
    }),

  }),
});

export const {
  useGetDenominationsQuery,
} = denominationApi;
